import type { CSSProperties } from 'preact'

export function XIcon({ style }: { style?: CSSProperties } = {}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      style={{
        display: 'block',
        flexShrink: 0,
        width: '24px',
        height: '24px',
        stroke: 'currentColor',
        strokeLinecap: 'round',
        strokeLinejoin: 'round',
        strokeWidth: 2,
        ...style,
      }}
    >
      <path d="M18 6 6 18" fill="none" />
      <path d="m6 6 12 12" fill="none" />
    </svg>
  )
}
